<template>
    <game-items-add game-item-variant="skybox" @added="redirectToEditPage">
        <template #title>{{ $t('skybox.add') }}</template>
    </game-items-add>
</template>

<script>
import GameItemsAdd from '@/views/game-items/game-items-add/GameItemsAdd.vue';

export default {
    components: {
        GameItemsAdd,
    },

    methods: {
        redirectToEditPage(response) {
            const { skybox_id: skyboxId = null } = response;

            if (skyboxId === null) return;

            this.$router.push({
                name: 'skybox-edit',
                params: { id: skyboxId },
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
